module.exports = "<label for=\"{{ id }}\">\n\t<span class=\"label-text\">Scale By</span>\n\n\t<select\n    name=\"scale\"\n    id=\"{{ id }}\"\n    (change)=\"scaleRecipe($event)\"\n  >\n    <option\n      *ngFor=\"let option of scaleOptions\"\n      [selected]=\"option.value === currentScale\"\n      value=\"{{ option.value }}\"\n    >{{ option.title }}</option>\n  </select>\n</label>"


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/scale-recipe/scale-recipe.html
// module id = ../../../../../src/app/components/scale-recipe/scale-recipe.html
// module chunks = 1